import Default from "./InputLabel";
export * from "./InputLabel";

export default Default;
